import React from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { selectStyle } from "../../models/selectStyle";
import { templateActions } from "../../../store/actions/cms/template/template.action";
import { Dialog, DialogContent, DialogTitle, IconButton, Slide } from "@material-ui/core";
import { deepClone } from "../../../helpers/objectHelper";
import Alert from "@material-ui/lab/Alert";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TemplateSelector = (props) => {
  const { dialog } = props;
  if (dialog) {
    return (
      <Dialog className="dark-dialog" open={true} TransitionComponent={Transition} onClose={() => null}>
        <DialogContent style={{ width: 350, minHeight: 120, position: "relative" }} className="dark-l2 dark-input">
          <TemplateSelectorGroup {...props} dialog={dialog} />
        </DialogContent>
      </Dialog>
    );
  }
  return <TemplateSelectorGroup {...props} />;
};

const TemplateSelectorGroup = (props) => {
  const { template, templates, dialog, dispatch, templateIsSavable, updateLayout, mainEventId } = props;
  let formGroupStyle = dialog
    ? {
        background: "transparent",
        position: "fixed",
      }
    : {
        padding: "10px 10px 15px",
        background: "#3f414c9e",
        marginTop: 10,
      };

  const layoutTemplateOnChange = (templateId) => {
    const { dispatch, layouts } = props;
    const selectedLayout = layouts.find((l) => l.meetingLayoutId == props.selectedLayout.value);
    if (selectedLayout) {
      const updatedLayout = deepClone(selectedLayout);
      updatedLayout.templateId = templateId;
      updateLayout(updatedLayout);
    }
    dispatch(templateActions.get(templateId));
  };

  const lang = props?.user?.userLang;
  const eventId = props?.user?.eid;

  return (
    <FormGroup style={formGroupStyle}>
      <Label className="primary-text">
        <SystemLabel name="SelectTemplate" />
      </Label>
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <Select
          classsName="jirango-select force"
          options={
            templates
              ? templates.map((t) => {
                  return {
                    value: t.templateId,
                    label: (
                      <div>
                        {t.eventId != mainEventId ? <AccountTreeIcon style={{ fontSize: 15, marginRight: 5 }} className="primary-text" /> : null} {t.name}
                      </div>
                    ),
                  };
                })
              : []
          }
          value={template ? { value: template.templateId, label: template.name } : null}
          onChange={(opt) => {
            layoutTemplateOnChange(opt.value);
          }}
          styles={{
            ...selectStyle,
          }}
        />
        <IconButton
          style={{ color: "#fff" }}
          onClick={() => {
            window.open(
              window.location.host?.includes("localhost") ? `https://localhost:44331/Template/List?eventId=${eventId}&languageCode=${lang}` : `https://jirango.com/Template/List?eventId=${eventId}&languageCode=${lang}`,
              "_blank"
            );
          }}
        >
          <OpenInNewIcon />
        </IconButton>
      </div>

      {templateIsSavable ? (
        <Alert severity="warning" style={{ marginTop: 5 }}>
          {" "}
          <SystemLabel name="CannotChangeTemplateUntilSaved" />
        </Alert>
      ) : null}
    </FormGroup>
  );
};

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    alert: state.alert,
    page: state.page,
    template: state.template.template,
    language: state.language,
    templateIsSavable: state.template.isSavable,
    templates: state.template ? state.template.templates : undefined,
    systemLabel: state.systemLabel,
  };
}
export default connect(mapStateToProps)(TemplateSelector);
